// MSH/frontend/src/api/designBackground/index.js
import toast from "react-hot-toast";
const { clientAPI } = require("../client");

// Hiển thị lỗi nhất quán
const showErrors = (error) => {
  const msgs = (error?.response?.data?.errors || []).map((e) => e.message) || [
    error?.response?.data?.message ||
      error?.response?.statusText ||
      error?.message ||
      "An unexpected error occurred.",
  ];
  msgs.forEach((m) => toast.error(`${m}`));
};

export const designBackgroundApi = {
  // List tất cả background để chọn
  list: async (params = {}) => {
    const options = {
      limit: params?.limit || 9999,
      page: params?.page || 1,
    };
    const queryParams = new URLSearchParams(options).toString();
    try {
      const res = await clientAPI(
        "get",
        `/designBanner/background?${queryParams}`
      );
      return res;
    } catch (error) {
      console.error("list error:", error);
      showErrors(error);
      throw error;
    }
  },

  listTypebyProjectAndBanner: async (params = {}) => {
    try {
      const options = {
        limit: 9999,
        page: 1,
      };
      if (params.projectId) options.projectId = params.projectId;
      const queryParams = new URLSearchParams(options).toString();
      const res = await clientAPI(
        "get",
        `/projectBannerLinks/listGroupBanner?${queryParams}`
      );
      return res;
    } catch (error) {
      console.error("listTypebyProjectAndBanner error:", error);
      showErrors(error);
      throw error;
    }
  },

  // Lấy 1 background (trả về data giống bạn paste)
  getOne: async (id) => {
    try {
      const res = await clientAPI("get", `/designBanner/background/${id}`);
      return res;
    } catch (error) {
      console.error("getOne error:", error);
      showErrors(error);
      throw error;
    }
  },

  // delete layout
  deleteOne: async (id) => {
    try {
      const res = await clientAPI("delete", `/designBanner/background/${id}`);
      return res;
    } catch (error) {
      console.error("delete error:", error);
      showErrors(error);
      throw error;
    }
  },

  // Lấy layout riêng
  getLayout: async (id) => {
    try {
      const res = await clientAPI(
        "get",
        `/designBanner/designBackground/${id}/layout`
      );
      return res;
    } catch (error) {
      console.error("getLayout error:", error);
      showErrors(error);
      throw error;
    }
  },

  // upload banner image
  uploadBannerImage: async (file) => {
    try {
      const formData = new FormData();
      if (file) formData.append("file", file);
      formData.append("uploadFolder", "banner");
      const response = await clientAPI(
        "post",
        "/common/upload/image",
        formData
      );
      return response; // trả về dạng { "filePath": "uploads/banner/1758184698373-default-avatar.webp" }
    } catch (error) {
      console.error("uploadBannerImage error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  // tạo layout
  createLayout: async (data) => {
    try {
      const res = await clientAPI("post", `/designBanner/background`, data);
      toast.success("Lưu layout thành công");
      return res;
    } catch (error) {
      console.error("createLayout error:", error);
      showErrors(error);
      throw error;
    }
  },

  // bulk action
  bulkAction: async (data) => {
    try {
      const res = await clientAPI(
        "post",
        `/projectBannerLinks/bulkAction`,
        data
      );
      toast.success("Lưu thành công");
      return res;
    } catch (error) {
      console.error("bulkAction error:", error);
      showErrors(error);
      throw error;
    }
  },

  // Cập nhật layout
  updateLayout: async (id, data) => {
    try {
      const res = await clientAPI(
        "put",
        `/designBanner/designBackground/${id}/layout`,
        data
      );
      toast.success("Lưu layout thành công");
      return res;
    } catch (error) {
      console.error("updateLayout error:", error);
      showErrors(error);
      throw error;
    }
  },
};
